import { mapMutations, mapGetters, mapActions } from "vuex";
import PromotionsSlider from "./components/slider/index.vue";
import Timer from "@/components/timer/index.vue";
import gallery from "@/modules/card/components/gallery-product/index.vue";
import promoItem from "@/modules/card/components/promo-item/index.vue";
import newItem from "@/modules/card/components/new-collection-item/index.vue";
import { VueSlideToggle } from "vue-slide-toggle";
import StarRating from "vue-star-rating";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import moment from "moment";
import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";
import Vue from "vue";
import _ from "lodash";

export default {
    name: "promotion-card",
    mixin: [validationMixin],
    data() {
        return {
            currentId: this.$route.params.id,
            payload: {
                name: "",
                comment: "",
                rating: 0,
                product_id: null,
                date: null,
                skip: 1,
            },
            params: {
                title: "",
                description: "",
                keywords: "",
                name: "",
            },
            page: 0,
            validationErrors: {},
            openPromo: true,
            openNew: true,
            openFullDescription: false,
            openFullCharacteristic: false,
            openReviews: false,
            editCount: 1,
            disableAddButton: false,
            discount: false,
            productCollection: {},
            products: {},
            currentProduct: {},
            startDate: 0,
            endDate: 0,
            currentAction: [],
            title: "",
            description: "",
            productItem: {},
            // someLoading: false
        };
    },

    head: {
        title: function() {
            return {
                inner: "Товари ",
                separator: "|",
                complement: this.params.name,
            };
        },
        meta: function() {
            let meta = [
                { n: "description", c: this.params.description, id: "description" },
                { n: "keywords", c: this.params.keywords, id: "keywords" },
                { n: "og:title", c: this.params.title, id: "og:title" },
                { n: "og:description", c: this.params.description, id: "og:description" },
            ];

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: "robots", c: "noindex, nofollow" });
                return meta;
            } else {
                return meta;
            }
        },
        link: function() {
            let route = this.$route.path;
            return [{ rel: "canonical", href: window.location.origin + this.$route.path, id: "canonical" }];
        },
    },
    validations() {
        return {
            payload: {
                name: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(20),
                },
                comment: {
                    required,
                    minLength: minLength(10),
                    maxLength: maxLength(100),
                },
            },
        };
    },
    components: {
        gallery,
        VueSlideToggle,
        "promo-item": promoItem,
        "new-item": newItem,
        StarRating,
        VueAdsPagination,
        VueAdsPageButton,
        Timer,
        PromotionsSlider,
    },
    watch: {
        $route(newVal) {
            if (newVal) {
                this.resetLimit();
                let obj = {};
                obj.slug = this.$route.params.slug;
                obj.promotion_slug = this.$route.params.promo;
                this.fetchPromoList(obj);
                this.fetchAllProducts(obj);
            }
        },
        product: function(newVal) {
            if (newVal) {
                var self = this;
                self.params.title = newVal.meta_title;
                self.params.description = newVal.meta_description;
                self.params.keywords = newVal.meta_keywords;
                self.params.image = newVal.meta_image;
                self.params.name = newVal.title;
                self.$emit("updateHead");
            }
        },
    },
    computed: {
        ...mapGetters({
            promoList: "card/promoList",
            promoListLength: "card/promoListLength",
            promoListLoading: "card/promoListLoading",
            newCollectionList: "card/newCollectionList",
            newCollectionListLength: "card/newCollectionListLength",
            newCollectionListLoading: "card/newCollectionListLoading",
            productLoading: "promotions/productLoading",
            basket: "basket/basket",
            countBasketItems: "basket/countBasketItems",
            reviewList: "card/reviewList",
            reviewListLength: "card/reviewListLength",
            reviewListLoading: "card/reviewListLoading",
            popupFastBuy: `card/popupFastBuy`,
            limit: "card/limit",
            isAuthenticated: "auth/isAuthenticated",
            popupRegister: "auth/popupRegister",
            sendReviewLoading: "card/sendReviewsLoading",
            getList: `promotions/getList`,
            getCurrentList: "promotions/getCurrentList",
            someLoading: `promotions/someLoading`,
            getProductsLength: `promotions/getProductsLength`,
            getCardsLength: `promotions/getCardsLength`,
        }),
        getProducts() {
            let arr = [];
            for (let i in this.getList) {
                this.startDate = this.getList[i].start_date;
                this.endDate = this.getList[i].end_date;
                this.title = this.getList[i].title;
                this.description = this.getList[i].description;

                for (let j in this.getList[i].products.data) {
                    if (this.getList[i].products.data[j].slug === this.$route.params.slug) {
                        arr.push(this.getList[i].products.data[j]);
                        this.productItem = this.getList[i].products.data[j];
                        return arr;
                    }
                }
            }
        },
        getCurrentPrice() {
            if (this.productItem.sale_start) {
                let period = `${this.startDate.slice(0, -8)},${this.endDate.slice(0, -8)}`;
                let currentDate = new Date().toISOString().split("T")[0];
                let dates = period.split(",");
                let result = moment(currentDate).isBetween(dates[0], dates[1], null, "()");

                if (!result && this.productItem.discount_price === 0) {
                    return this.productItem.price;
                } else {
                    this.discount = true;
                    return this.productItem.discount_price;
                }
            } else {
                return this.productItem.price;
            }
        },
        getUnit() {
            if (this.productItem.unit !== null) {
                return "/" + this.productItem.unit;
            }
        },
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        commentErrors() {
            let error = [];
            if (!this.$v.payload.comment.$dirty) {
                return error;
            }
            if (!this.$v.payload.comment.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.comment.minLength) {
                error.push(this.$t("validationMin") + " 10");
            }
            if (!this.$v.payload.comment.maxLength) {
                error.push(this.$t("validationMax") + " 100");
            }
            if (this.validationErrors.comment) {
                this.validationErrors.comment.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.name === "" || this.payload.comment === "") {
                return true; // this.fetchPromoList()
            }
            return false;
        },
        replaceTags() {
            if (this.productItem.description !== null) {
                return this.productItem.description.replace(/(<([^>]+)>)/g, "");
            }
        },
    },
    created() {
        let obj = {};
        obj.slug = this.$route.params.slug;
        obj.promotion_slug = this.$route.params.promo;

        this.resetLimit();
        this.fetchPromoList(obj);
        this.fetchAllProducts(obj);
    },
    methods: {
        ...mapActions({
            fetchPromoList: `promotions/GET_PROMOTIONS_LIST`,
            fetchAllProducts: `promotions/GET_PROMOTIONS_CURRENT_LIST`,
            fetchNewCollectionList: `card/GET_NEW_COLLECTION_LIST`,
            fetchProduct: `card/GET_PRODUCT`,
            fetchReviews: `card/GET_PRODUCT_REVIEWS`,
            sendReview: `card/SEND_REVIEW`,
            addFavourite: `favorites/ADD_PRODUCT_TO_FAVORITE`,
            fetchFavourite: `favorites/GET_FAVORITES_LIST`,
            addProductToBasket: `basket/ADD_PRODUCT_TO_BASKET`,
        }),
        ...mapMutations({
            resetBreadcrumbs: `system/RESET_CUSTOM_BREADCRUMBS_LIST`,
            addBasket: `basket/ADD_ITEM_TO_BASKET`,
            reset: `basket/RESET_AVAILABILITY_PROPS`,
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            changePage: `card/REVIEWS_CHANGE_PAGE`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            resetProduct: `card/RESET_PRODUCT`,
            resetSkip: `promotions/RESET_SKIP`,
            resetLimit: `promotions/RESET_LIMIT`,
        }),
        test() {
            this.$emit("");
        },
        addToBasket(product) {
            if (this.editCount > this.productCollection.count) {
                this.$toasted.error(this.$t(`thisProductCount ${product.count}`));
            } else {
                this.addBasket({
                    select_count: this.editCount,
                    select_price: this.productCollection.discount_price
                        ? this.productCollection.discount_price
                        : this.productCollection.price,
                    min_price: this.productCollection.min_price,
                    ...product,
                });
                this.$toasted.success(this.$t("successAddBasket"));
                this.editCount = 1;
            }
        },
        decrementBasketItem() {
            this.editCount--;
        },
        incrementBasketItem() {
            this.editCount++;
        },
        setRating: function(rating) {
            this.payload.rating = rating;
        },
        resetForm() {
            this.$v.$reset();
            this.payload.name = "";
            this.payload.comment = "";
            this.payload.rating = 0;
            this.product_id = null;
            this.date = null;
        },
        changeRegister() {
            this.changePopupRegister({
                show: true,
                isRedirect: false,
            });
        },
        changePopup(status) {
            this.changeFastBuy({
                show: status,
                product_id: this.product.id,
                count: this.editCount,
            });
        },
        changePageLocal(page) {
            this.page = page;
            this.changePage(page + 1);
            let reviewObj = {};
            reviewObj.id = this.product.id;
            this.fetchReviews(reviewObj);
            this.$smoothScroll({
                scrollTo: this.$refs.reviews,
                duration: 500,
                offset: -60,
                updateHistory: false,
            });
        },
        changeWordMarks(count) {
            let titles = [this.$t("markWord1"), this.$t("markWord2"), this.$t("markWord3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
        },
        changeWordReviews(count) {
            let titles = [this.$t("reviewWord1"), this.$t("reviewWord2"), this.$t("reviewWord3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
        },
        addToFavourite(product) {
            if (this.isAuthenticated) {
                this.addFavourite(product)
                    .then(() => {
                        this.$toasted.success(this.$t("successAddFavourites"));
                        this.fetchFavourite();
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 422) {
                            console.log(this.validationErrors);
                        }
                    });
            } else {
                this.changePopupRegister({ show: true, isRedirect: false });
            }
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.payload.product_id = this.product.id;
                this.payload.date = moment(new Date()).format("YYYY-MM-DD");
                let reviewObj = {};
                reviewObj.id = this.product.id;
                this.sendReview(this.payload)
                    .then(() => {
                        this.$toasted.success(this.$t("successAddReview"));
                        this.fetchReviews(reviewObj).then(() => {
                            this.resetForm();
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            Object.assign(this.validationErrors, error.response.data.errors);
                            console.log(this.validationErrors);
                            this.resetForm();
                        }
                    });
            }
        },
    },
    destroyed() {
        this.resetProduct();
    },
};
